import { Component, inject } from '@angular/core';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { AsyncPipe, NgClass } from '@angular/common';
import { combineLatest, map, Observable } from 'rxjs';
import { CheckoutStep } from '@boels/models';
import { CheckoutStepService } from './checkout-step.service';
import { CartFacade } from '@boels/shared-state';
import { GenericLinkComponent } from '../../generic-link/generic-link.component';

@Component({
  selector: 'boels-checkout-step',
  templateUrl: './checkout-step.component.html',
  styleUrls: ['./checkout-step.component.scss'],
  imports: [
    FontAwesomeModule,
    GenericLinkComponent,
    TranslocoModule,
    AsyncPipe,
    NgClass,
  ],
  providers: [
    CheckoutStepService,
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['checkout'],
    },
  ],
})
export class CheckoutStepComponent {
  private checkoutStepFacade = inject(CheckoutStepService);
  private cartFacade = inject(CartFacade);

  faChevronRight = faChevronRight;

  checkoutProgress$: Observable<{
    index: number;
    checkoutSteps: CheckoutStep[];
  }> = combineLatest([
    this.cartFacade.getActiveStepNumber(),
    this.checkoutStepFacade.getCheckoutSteps(),
  ]).pipe(
    map(([index, checkoutSteps]: [number, CheckoutStep[]]) => ({
      index,
      checkoutSteps,
    })),
  );
}
